/**
 * In-code feature flags for EV coverage manual edit behavior.
 *
 * Toggle constants here and redeploy to enable or retract behavior.
 *
 * @module coverageInfo/config/evCoverageEditFlags
 */

/**
 * When true, Save blocks empty editable values and shows submit-time errors on invalid fields.
 * When false, empty values may persist as null/undefined (legacy behavior).
 */
export const EV_COVERAGE_REQUIRE_FIELDS_ON_SAVE = true;

/**
 * Orders with date of work on or before this day skip Continue validation (legacy orders).
 * Orders after this date run Continue validation when the facility `validate_ev` flag is on.
 */
export const EV_COVERAGE_CONTINUE_VALIDATION_DATE_OF_WORK_CUTOFF = "2026-06-07";
